import { useEffect, useMemo } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

function ShopifyProcessing() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const storeName = useMemo(() => String(searchParams.get('store') || '').trim(), [searchParams]);

  useEffect(() => {
    if (!storeName) {
      navigate('/shopify-connect', { replace: true });
      return;
    }

    let shop = storeName?.trim()?.toLowerCase();
    shop = shop?.replace(/^https?:\/\//, '')?.split('/')[0];

    if (!shop.includes('.')) shop = `${shop}.myshopify.com`;

    shop = shop.replace(/(\.myshopify\.com)+$/i, '.myshopify.com');

    const isValid = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop);
    if (!isValid) {
      navigate('/shopify-connect', { replace: true });
      return;
    }

    const redirectUri = `${window.location.origin}/shopify/callback`
    const scopes = 'read_products,write_products,read_draft_orders,write_draft_orders,read_orders,write_orders,read_customers,write_customers,read_inventory,write_inventory,read_locations,read_fulfillments,write_fulfillments,read_merchant_managed_fulfillment_orders,write_merchant_managed_fulfillment_orders'


    const arr = new Uint8Array(16)
    window.crypto.getRandomValues(arr)
    const state = Array.from(arr).map(b => b.toString(16).padStart(2, '0')).join('')
    sessionStorage.setItem('shopify_oauth_state', state)
    sessionStorage.setItem('shopify_oauth_shop', shop)

    const clientId = '9a4330f5cc0249e85ce3eaf848328ff1'
    const url =
      `https://${shop}/admin/oauth/authorize` +
      `?client_id=${encodeURIComponent(clientId)}` +
      `&scope=${encodeURIComponent(scopes)}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&state=${encodeURIComponent(state)}`

    const timer = setTimeout(() => {
      window.location.href = url
    }, 300)

    return () => clearTimeout(timer);
  }, [storeName, navigate]);


  return (
    <div className="min-h-[200px] flex flex-col items-center justify-center gap-2">
      <div className="text-lg font-medium font-montserrat">Connecting your Shopify store…</div>
      <div className="text-sm text-gray-600 font-montserrat">Please wait, redirecting to Shopify.</div>
    </div>
  )
}

export default ShopifyProcessing